var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHyperthyroidism(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20.67367 19.915094",
    id: "svg46",
    width: 21,
    height: 20,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs14"
  }, /*#__PURE__*/React.createElement("style", {
    id: "style1"
  }, "\n      .hyperthyroidism-cls-1 {\n        clip-path: url(#clippath-6);\n      }\n\n      .hyperthyroidism-cls-2 {\n        clip-path: url(#clippath-7);\n      }\n\n      .hyperthyroidism-cls-3 {\n        clip-path: url(#clippath-4);\n      }\n\n      .hyperthyroidism-cls-4 {\n        clip-path: url(#clippath-9);\n      }\n\n      .hyperthyroidism-cls-5 {\n        clip-path: url(#clippath-10);\n      }\n\n      .hyperthyroidism-cls-6 {\n        clip-path: url(#clippath-11);\n      }\n\n      .hyperthyroidism-cls-7, .hyperthyroidism-cls-8 {\n        fill: none;\n      }\n\n      .hyperthyroidism-cls-9 {\n        clip-path: url(#clippath-1);\n      }\n\n      .hyperthyroidism-cls-10 {\n        clip-path: url(#clippath-5);\n      }\n\n      .hyperthyroidism-cls-11 {\n        clip-path: url(#clippath-8);\n      }\n\n      .hyperthyroidism-cls-12 {\n        clip-path: url(#clippath-3);\n      }\n\n      .hyperthyroidism-cls-13 {\n        clip-path: url(#clippath-12);\n      }\n\n      .hyperthyroidism-cls-8 {\n        stroke: #000;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 1.5px;\n      }\n\n      .hyperthyroidism-cls-14 {\n        clip-path: url(#clippath-2);\n      }\n\n      .hyperthyroidism-cls-15 {\n        clip-path: url(#clippath-13);\n      }\n\n      .hyperthyroidism-cls-16 {\n        clip-path: url(#clippath);\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-6"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "hyperthyroidism-cls-7",
    x: 33.18,
    y: 4.04,
    width: 9.9099998,
    height: 19.92,
    id: "rect7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-7"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "hyperthyroidism-cls-7",
    x: 43.080002,
    y: 4.04,
    width: 9.9099998,
    height: 19.92,
    id: "rect8"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-8"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "hyperthyroidism-cls-7",
    x: 32.619999,
    y: 10.62,
    width: 7.1199999,
    height: 11.89,
    id: "rect9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-9"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "hyperthyroidism-cls-7",
    x: 46.18,
    y: 10.62,
    width: 7.1199999,
    height: 11.89,
    id: "rect10"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-10"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "hyperthyroidism-cls-7",
    x: 35.889999,
    y: 13.43,
    width: 5.3899999,
    height: 6.1900001,
    id: "rect11"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-11"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "hyperthyroidism-cls-7",
    x: 44.900002,
    y: 13.43,
    width: 5.3899999,
    height: 6.1900001,
    id: "rect12"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g46",
    transform: "translate(-32.623165,-4.0449046)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g40"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g39"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g31"
  }, /*#__PURE__*/React.createElement("g", {
    className: "hyperthyroidism-cls-1",
    clipPath: "url(#clippath-6)",
    id: "g28"
  }, /*#__PURE__*/React.createElement("line", {
    className: "hyperthyroidism-cls-8",
    x1: 39.380001,
    y1: 23.15,
    x2: 43.07,
    y2: 23.209999,
    id: "line27"
  }), /*#__PURE__*/React.createElement("path", {
    className: "hyperthyroidism-cls-8",
    d: "m 38.84,18.69 c 0.47,2.35 0.43,4.4 0.43,4.4",
    id: "path27"
  }), /*#__PURE__*/React.createElement("path", {
    className: "hyperthyroidism-cls-8",
    d: "M 43.97,8.29 C 43.09,8.72 42.37,8.37 42.16,8.24 41.34,7.72 41.26,6.96 40.78,6.11 v 0 C 40.14,4.97 38.75,4.49 37.54,4.99 v 0 c -2.4,1 -5.09,5.25 -2.66,6.16 1.41,0.53 2.36,1.83 3.01,3.38",
    id: "path28"
  })), /*#__PURE__*/React.createElement("g", {
    className: "hyperthyroidism-cls-2",
    clipPath: "url(#clippath-7)",
    id: "g30"
  }, /*#__PURE__*/React.createElement("line", {
    className: "hyperthyroidism-cls-8",
    x1: 46.779999,
    y1: 23.15,
    x2: 43.099998,
    y2: 23.209999,
    id: "line28"
  }), /*#__PURE__*/React.createElement("path", {
    className: "hyperthyroidism-cls-8",
    d: "m 47.32,18.69 c -0.47,2.35 -0.43,4.4 -0.43,4.4",
    id: "path29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "hyperthyroidism-cls-8",
    d: "m 42.2,8.29 c 0.88,0.43 1.6,0.08 1.81,-0.05 0.82,-0.52 0.9,-1.28 1.38,-2.13 v 0 c 0.64,-1.14 2.03,-1.62 3.24,-1.12 v 0 c 2.4,1 5.09,5.25 2.66,6.16 -1.41,0.53 -2.36,1.83 -3.01,3.38",
    id: "path30"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g34"
  }, /*#__PURE__*/React.createElement("g", {
    className: "hyperthyroidism-cls-11",
    clipPath: "url(#clippath-8)",
    id: "g32"
  }, /*#__PURE__*/React.createElement("path", {
    className: "hyperthyroidism-cls-8",
    d: "m 34.72,11.37 -0.26,0.33 c -0.57,0.72 -0.81,1.67 -0.65,2.59 l 0.16,0.93 -0.25,0.51 c -0.68,1.37 -0.33,3.05 0.82,4.02 l 0.2,0.17 0.56,0.6 c 1.37,1.45 3.68,1.22 3.68,1.22",
    id: "path31"
  })), /*#__PURE__*/React.createElement("g", {
    className: "hyperthyroidism-cls-4",
    clipPath: "url(#clippath-9)",
    id: "g33"
  }, /*#__PURE__*/React.createElement("path", {
    className: "hyperthyroidism-cls-8",
    d: "m 51.2,11.37 0.26,0.33 c 0.57,0.72 0.81,1.67 0.65,2.59 l -0.16,0.93 0.25,0.51 c 0.68,1.37 0.33,3.05 -0.82,4.02 l -0.2,0.17 -0.56,0.6 c -1.37,1.45 -3.68,1.22 -3.68,1.22",
    id: "path32"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g38"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "hyperthyroidism-cls-5",
    clipPath: "url(#clippath-10)",
    id: "g35"
  }, /*#__PURE__*/React.createElement("path", {
    className: "hyperthyroidism-cls-8",
    d: "m 36.64,14.18 c 0.09,0.53 3.15,0.66 3.24,0.62",
    id: "path34"
  }), /*#__PURE__*/React.createElement("path", {
    className: "hyperthyroidism-cls-8",
    d: "M 37.26,18.88 C 38.39,18.05 40.5,18.1 40.53,18.2",
    id: "path35"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "hyperthyroidism-cls-6",
    clipPath: "url(#clippath-11)",
    id: "g37"
  }, /*#__PURE__*/React.createElement("path", {
    className: "hyperthyroidism-cls-8",
    d: "m 49.53,14.18 c -0.09,0.53 -3.15,0.66 -3.24,0.62",
    id: "path36"
  }), /*#__PURE__*/React.createElement("path", {
    className: "hyperthyroidism-cls-8",
    d: "M 48.91,18.88 C 47.78,18.05 45.67,18.1 45.64,18.2",
    id: "path37"
  }))))), /*#__PURE__*/React.createElement("polyline", {
    points: "41.86 22.9 41.86 16.61 40.83 16.61 43.08 12.78 45.33 16.61 44.31 16.61 44.31 22.9",
    id: "polyline39"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHyperthyroidism);
export default __webpack_public_path__ + "static/media/Hyperthyroidism.60411a4e2c0dfe775373d3e9c26380a3.svg";
export { ForwardRef as ReactComponent };